import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useNavigate } from "react-router-dom";
import SocialProofBox from "../../Components/For Individuals/SocialProofBox";
import {
  getButtonByPartner,
  getForIndividualsParaByPartner,
  getForIndividualsStepByPartner,
} from "../../api/axios";
import useSWR from "swr";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {getDataByPageAndPosition} from "../../Frontend/Components/Common/common"


function Forindividuals() {
  const [indivisulHeaderButton, setIndivisulHeaderButton] = useState();
  const [indivisulBottomButton, setIndivisulBottomButton] = useState();

  const { data: data = {} } = useSWR(
    `getForIndividualsPara`,
    async () => {
      try {
        const { data } = await getForIndividualsParaByPartner();
        const paraData = data.data[0];
        return { ...paraData, index: data.data.indexOf(paraData) };
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const { data: step = {} } = useSWR(
    `getForIndividualsStep`,
    async () => {
      try {
        const { data } = await getForIndividualsStepByPartner();
        const stepData = data.data[0];
        return { ...stepData, index: data.data.indexOf(stepData) };
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const { data: buttons = [] } = useSWR(
    `getForIndividualsgetButton`,
    async () => {
      try {
        const { data } = await getButtonByPartner();
        const headerButton = getDataByPageAndPosition(data?.data || [], "For Individuals", "Header section") || [];
        setIndivisulHeaderButton(headerButton || []);
        const bottomButton = getDataByPageAndPosition(data?.data || [], "For Individuals", "Bottom section") || [];
        setIndivisulBottomButton(bottomButton || []);

        return data?.data;
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const cell_data = [
    {
      no: "01",
      text: step.step1,
    },
    {
      no: "02",
      text: step.step2,
    },
    {
      no: "03",
      text: step.step3,
    },
    {
      no: "04",
      text: step.step4,
    },
  ];

  let navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const theme = useTheme();
  const Body = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-rows: repeat(2, auto);
    margin: 0 auto;
    
    @media (max-width: 768px) {
      padding: 15px;
      grid-gap: 0px;
    }
    
    @media (max-width: 480px) {
      grid-gap: 0px;
    }

    button {
      width: 259px;
      height: 55px;
      background: ${theme.palette.primary.main};
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
      border: none;
      border-radius: 30px;
      color: #ffff;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      letter-spacing: -0.011em;
      text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
      margin-bottom: 50px;

      @media (max-width: 768px) {
        width: 220px;
        height: 50px;
        font-size: 18px;
        margin-bottom: 30px;
      }
      
      @media (max-width: 480px) {
        width: 200px;
        height: 45px;
        font-size: 16px;
        margin-bottom: 20px;
      }

      :hover {
        transform: translateY(-1px);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1),
          0px 20px 20px rgba(0, 0, 0, 0.15),
          inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.15);
      }
    }
  `;

  const Button = styled.div`
    width: 255px;
    height: 55px;
    cursor: pointer;
    background: ${theme.palette.primary.main};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-weight: 700;
    font-size: 24px;
    line-height: 50px;
    text-align: center;
    letter-spacing: -0.011em;
    transition-duration: 0.9s;
    color: #ffffff;
    text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    margin: ${step.length > 0 ? "20px 0" : "auto"};
    
    @media (max-width: 768px) {
      width: 220px;
      height: 50px;
      font-size: 20px;
      line-height: 45px;
      margin: 15px 0;
    }
    
    @media (max-width: 480px) {
      width: 200px;
      height: 45px;
      font-size: 18px;
      line-height: 40px;
      margin: 10px 0;
    }
    
    :hover {
      transform: translateY(-3px);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1),
        0px 20px 20px rgba(0, 0, 0, 0.15),
        inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.15);
    }
  `;
  const Hero = styled.div`    
    h1 {
      font-weight: 700;
      font-size: 50px;
      color: ${theme.palette.text.main};
      text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
      line-height: 1.2;
      margin-bottom: 20px;
      
      @media (max-width: 1100px) {
        font-size: 45px;
      }
      @media (max-width: 975px) {
        font-size: 40px;
        line-height: 1.1;
      }
      @media (max-width: 895px) {
        font-size: 38px;
      }
      @media (max-width: 855px) {
        letter-spacing: -0.01em;
        font-size: 35px;
      }
      @media (max-width: 715px) {
        font-size: 28px;
        line-height: 1.2;
        text-align: center;
        margin: 15px 0;
        padding: 0 10px;
      }
      @media (max-width: 480px) {
        font-size: 24px;
        line-height: 1.3;
        margin: 10px 0;
        padding: 0 5px;
      }
    }
    h3 {
      ${
        "" /* font-family: "Omnes";
    font-style: normal; */
      }
      font-weight: 800;
      font-size: 35px;
      color: #06476c;
      margin-bottom: 15px;
      
      @media (max-width: 1100px) {
        font-size: 33px;
      }
      @media (max-width: 975px) {
        font-size: 30px;
        line-height: 1.1;
      }
      @media (max-width: 895px) {
        font-size: 28px;
      }
      @media (max-width: 715px) {
        font-size: 22px;
        line-height: 1.3;
        padding: 0;
        margin: 0 0 15px 0;
         text-align: center;
      }
    }
  `;
  const MainCell = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 60px;
  display: grid;
  grid-gap: 86px;
  grid-template-columns: ${step.length > 0 ? "1.32fr 1fr" : "1fr"};
  
  @media (max-width: 1130px) {
    display: grid;
    grid-gap: 40px;
    grid-template-columns: repeat(1, auto);
    margin-top: 40px;
    margin-bottom: 40px;
  }
  
  @media (max-width: 768px) {
    grid-gap: 30px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  
  @media (max-width: 460px) {
    margin-top: 20px;
    margin-bottom: 20px;
    grid-gap: 0px;
  } 
`;

  return (
    <div>
      <Body>
        <Hero>
          <h3>Peace of Mind for</h3>
          <h1>
            <Box
              component="span"
              sx={{ color: `${theme.palette.primary.main}` }}
            >
              {" "}
              Pet{" "}
            </Box>
            Owners
          </h1>
        </Hero>
        <Image>
          <img src={data.headerImage} alt="body" />
        </Image>

        <MainCell>
        {step.length > 0 &&
          <Sec>
            {cell_data.map((item, i) => (
                <CellGroup key={i}>
                  <CellNo>{item.no}</CellNo>
                  <CellText>{item.text}</CellText>
                </CellGroup>
              ))}
          </Sec>
          }
          <Para>
            <Text>{data.paragraph}</Text>
            {indivisulHeaderButton?.length > 0 && <Button
              onClick={() => {
                navigate(indivisulHeaderButton?.[0]?.buttonLink);
              }}
            >
              {indivisulHeaderButton?.[0]?.button_name}
            </Button>}
          </Para>
        </MainCell>
        <SocialProofBox />

       {indivisulBottomButton?.length > 0 && (
         <BottomButtonContainer>
           <button
             onClick={() => navigate(indivisulBottomButton?.[0]?.buttonLink)}
           >
             {indivisulBottomButton?.[0]?.button_name}
           </button>
         </BottomButtonContainer>
       )}
      </Body>
    </div>
  );
}

export default Forindividuals;

const Sec = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, auto);
  
  @media (max-width: 830px) {
    grid-template-columns: repeat(1, auto);
    grid-gap: 15px;
  }
  
  @media (max-width: 480px) {
    grid-gap: 10px;
  }
`;

const Text = styled.div`
  font-weight: 550;
  font-size: 23px;
  line-height: 28px;
  text-align: justify;
  color: #000000;
  margin-bottom: 20px;

  @media (max-width: 1028px) {
    font-size: 20px;
    line-height: 26px;
  }
  
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 15px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
  }
`;
// const Button = styled.div`
//   width: 255px;
//   height: 55px;
//   cursor: pointer;
//   background: #ff8533;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
//   border-radius: 30px;
//   font-weight: 700;
//   font-size: 24px;
//   line-height: 24px;
//   /* or 100% */
//   text-align: center;
//   letter-spacing: -0.011em;
//   transition-duration: 0.9s;
//   line-height: 50px;

//   color: #ffffff;

//   text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
//   :hover {
//     transform: translateY(-3px);
//     box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1),
//       0px 20px 20px rgba(0, 0, 0, 0.15),
//       inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.15);
//   }
// `;
const Para = styled.div`
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

const Image = styled.div`
max-height: 630px;
  img {
    border-radius: 10px;
    width: 100%;
    height: auto;
    max-height: 100%;
  }
`;



const CellGroup = styled.div`
  padding-left: 30px;
  padding-bottom: 25px;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, auto);
  
  @media (max-width: 768px) {
    padding-left: 20px;
    padding-bottom: 20px;
    grid-gap: 20px;
  }
  
  @media (max-width: 500px) {
    padding-left: 15px;
    padding-bottom: 15px;
    grid-gap: 15px;
  }
  
  @media (max-width: 480px) {
    padding-left: 10px;
    padding-bottom: 10px;
    grid-gap: 10px;
  }
`;

const CellNo = styled.div`
  font-weight: 500;
  font-size: 32px;
  line-height: 40px;
  color: #3ca899;
  display: grid;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 35px;
  }
  
  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

const CellText = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  letter-spacing: -0.011em;
  width: 100%;
  color: #000000;
  
  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 19px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

const BottomButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  @media (max-width: 480px) {
    margin-top: 20px;
  }
`;


